import React from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';
import Checkbox from '../../../../view/view-checkbox';
import { isDragula } from '../../../../util/cubeUtil';
import ModeExcel from '../../../../stores/card/ModeExcel';
import CardStore from '../../../../stores/card';

export interface DetailCheckAllProps{
    excel: ModeExcel;
    form: any;
    card: CardStore;
    detail?: string;
}

@observer
export default class DetailCheckAll extends React.Component<DetailCheckAllProps, any> {
    render() {
        const { card, detail, form, excel } = this.props;
        let viewAttr = card.params.type == '1' || card.params.type == '2' ? 2 : 1;
        const isNeedPagination = this.isNeedPagination();
        const { pageNum, pageSize } = form.$(detail);
        let detailFieldValues = form.$(detail).values();
        if (isNeedPagination) { // 明细表启用分页时，全选只选中当前页数据
            detailFieldValues = detailFieldValues.slice((pageNum-1)*pageSize, pageNum*pageSize);
        }
        let _values: string[];
        const { isCopy = false, isDelete = false } = excel.detailProps;
        if (!isDelete && detail) {    //如果设置了不允许删除已有明细
            _values = detailFieldValues.filter(val => !val.dtl_id);
            _values = _.values(_.mapValues(_values, 'checkbox'));
        } else {
            _values = _.values(_.mapValues(detailFieldValues, 'checkbox'));
        }
        if(card.params.type == '0' && isCopy ||isDelete){ //显示布局下。允许快速编辑，开启删除‘复制功能允许勾选
            viewAttr = 2;
        }
        const __values = _values.filter(d => d == '1');
        const checkAll = __values.length > 0 && __values.length == _values.length; // 是否全选
        const checkSome = __values.length > 0 && __values.length < _values.length;
        const id = "_" + detail + "_all";
        let style={};
        let isDrag=isDragula(card,detail);
        if(isDrag){
            style={marginLeft:17};
        }
        return (
            <Checkbox ecId={`${this && this.props && this.props.ecId || ''}_Checkbox@ss6zqp`} style={style}
                {...{ id: id, name: id }}
                onChange={this.checkAllChange}
                indeterminate={checkSome}
                checkAll={checkAll}
                disabled={viewAttr == 1}
            />
        )
    }

    checkAllChange = (e) => {
        const { checked } = e.target;
        const { detail, form, excel } = this.props;
        const isNeedPagination = this.isNeedPagination();
        let canNotDeleteHis: boolean = false;
        if (!excel.detailProps.isDelete && detail) {
            canNotDeleteHis = true;
        }

        form.checkAll(detail, checked, isNeedPagination, canNotDeleteHis);
    }

    // 判断是否启用分页
    isNeedPagination = () => {
        const { card, excel } = this.props;
        const { isPagination = false } = excel.detailProps;
        return (card.base.type == '0' || card.base.type == '1' || card.base.type == '2') && isPagination;
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/checkbox-element/DetailCheckAll.tsx